var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "box", attrs: { shadow: "hover" } },
    [
      _vm.showModal
        ? _c("app-modal-gerenciamento-modulos", {
            attrs: { moduloParaEditar: _vm.moduloParaEditar },
            on: {
              closeModal: _vm.closeModal,
              adicionar: _vm.adicionar,
              atualizarModulo: _vm.atualizarModulo
            }
          })
        : _vm._e(),
      _c("h1", [_vm._v("Modulos")]),
      _c(
        "div",
        { staticClass: "containerBotao" },
        [
          _c("span", [_vm._v("Módulos / serviços existentes")]),
          _c(
            "el-button",
            {
              staticClass: "botaoAdd",
              attrs: { type: "primary", icon: "el-icon-plus", id: "botao-add" },
              on: { click: _vm.abrirModal }
            },
            [_vm._v("Cadastrar")]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "modulosContainer" },
        _vm._l(_vm.modulos, function(modulo) {
          return _c(
            "div",
            { key: modulo.id, staticClass: "modulo" },
            [
              _c(
                "el-row",
                {
                  staticClass: "nomeModuloContainer",
                  attrs: { type: "flex", justify: "space-between" }
                },
                [
                  _c("span", { staticClass: "titulo" }, [
                    _c("i", {
                      staticClass: "fa fa-circle",
                      style: {
                        "margin-right": "10px",
                        "font-size": "22px",
                        color:
                          modulo.status === "OK"
                            ? "rgb(86, 242, 86)"
                            : modulo.status === "DESLIGADO"
                            ? "rgb(254, 49, 49)"
                            : "rgba(0, 0, 0, 0.10)"
                      }
                    }),
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm.encurtarString(
                            modulo.nome.length,
                            39,
                            modulo.nome
                          )
                        )
                      )
                    ])
                  ]),
                  _c(
                    "el-dropdown",
                    { attrs: { trigger: "click" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 2 } },
                        [
                          _c("i", {
                            staticClass: "fa fa-ellipsis-v",
                            style: { "font-size": "22px", cursor: "pointer" }
                          }),
                          [
                            _c(
                              "el-dropdown-menu",
                              [
                                modulo.status === "DESLIGADO"
                                  ? _c("el-dropdown-item", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "moduloAcao",
                                          on: {
                                            click: function($event) {
                                              return _vm.executarComandoModulo(
                                                modulo.id,
                                                "LIGAR"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "far fa-power-off",
                                            style: {
                                              "font-size": "20px",
                                              "margin-right": "8px"
                                            }
                                          }),
                                          _c("p", [_vm._v("Ativar")])
                                        ]
                                      )
                                    ])
                                  : _c("el-dropdown-item", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "moduloAcao",
                                          on: {
                                            click: function($event) {
                                              return _vm.executarComandoModulo(
                                                modulo.id,
                                                "DESLIGAR"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-power-off",
                                            style: {
                                              "font-size": "20px",
                                              "margin-right": "8px"
                                            }
                                          }),
                                          _c("p", [_vm._v("Desativar")])
                                        ]
                                      )
                                    ]),
                                _c("el-dropdown-item", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "moduloAcao",
                                      on: {
                                        click: function($event) {
                                          return _vm.executarComandoModulo(
                                            modulo.id,
                                            "REINICIAR"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        style: {
                                          "font-size": "20px",
                                          "margin-right": "8px"
                                        },
                                        attrs: {
                                          src: _vm.icone,
                                          alt: "icone de reiniciar"
                                        }
                                      }),
                                      _c("p", [_vm._v("Reiniciar")])
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "linha" }),
              _c("span", { staticClass: "vistoPorUltimo" }, [
                _c("p", [
                  _c("i", [
                    _vm._v("Visto por ultimo: " + _vm._s(modulo.vistoPorUltimo))
                  ])
                ])
              ]),
              _c("div", { staticClass: "infoModulos" }, [
                _c("p", [
                  _c("strong", { staticClass: "dado" }, [
                    _vm._v("Nome servico:")
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.encurtarString(
                          modulo.nomeDoServico.length,
                          33,
                          modulo.nomeDoServico
                        )
                      )
                    )
                  ])
                ]),
                _c("p", [
                  _c("strong", { staticClass: "dado" }, [_vm._v("Ip:")]),
                  _c("span", [_vm._v(_vm._s(modulo.ip))])
                ]),
                _c("p", [
                  _c("strong", { staticClass: "dado" }, [_vm._v("Porta:")]),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.encurtarString(
                          modulo.porta.length,
                          30,
                          modulo.porta
                        )
                      )
                    )
                  ])
                ]),
                _c("p", [
                  _c("strong", { staticClass: "dado" }, [_vm._v("Status:")]),
                  _c("span", [_vm._v(_vm._s(modulo.statusFormatado))])
                ])
              ]),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-between" } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "botao",
                      on: {
                        click: function($event) {
                          return _vm.deletarModulo(modulo.id)
                        }
                      }
                    },
                    [_vm._v("Remover")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "botao",
                      on: {
                        click: function($event) {
                          return _vm.editarModulo(modulo)
                        }
                      }
                    },
                    [_vm._v("Editar")]
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ee56a90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ee56a90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/GerenciarModulos.vue
// module id = null
// module chunks = 